import styled from 'styled-components';

export const DropdownContentContainer = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  box-shadow: var(--shadow-1);
`;
